import React from 'react';
import { Button, FlexRow, IconSize, IconType, ModalSubstrate } from 'ui-toolkit';
import CostDataModal from '../CostDataModal';
import { RotateIcon } from '../RotateIcon.styled';
import { StyledItemMetaDataModalCard } from './ItemMetaDataModal/ItemMetaDataModal.styled';

export interface IPurchaseItemMetaDataModalProps extends React.ComponentPropsWithoutRef<'div'> {
  expanded?: boolean;
  expandedLabel?: React.ReactNode | string;
  hideBorder?: boolean;
  label: React.ReactNode | string;
  onToggle?: (expanded: boolean) => void;
}

export interface IPurchaseItemMetaDataModalRef {
  modalContains: (element: HTMLElement) => boolean;
}

// tslint:disable-next-line:function-name
const PurchaseItemMetaDataModal = React.forwardRef<IPurchaseItemMetaDataModalRef, IPurchaseItemMetaDataModalProps>(
  ({ children, expanded, expandedLabel, hideBorder, label, onToggle }, ref) => {
    const [expandedState, setExpandedState] = React.useState(expanded);
    const [prevExpandedProp, setPrevExpandedProp] = React.useState(expanded);
    const cardModal = React.useRef<any>(null);
    const toggleExpansion = () => setExpandedState(!expandedState);

    if (expanded !== prevExpandedProp) {
      setExpandedState(expanded);
      setPrevExpandedProp(expanded);
    }

    React.useImperativeHandle(ref, () => ({
      modalContains: (element: HTMLElement) => (cardModal.current ? !!cardModal.current.contains(element) : false),
    }));

    React.useEffect(() => {
      if (onToggle) {
        onToggle(expandedState === true);
      }
    }, [expandedState, onToggle]);

    return (
      <>
        <FlexRow justifyContent={'space-between'} width={100} onClick={toggleExpansion}>
          <span>{label}</span>
          <Button intent="ghost" isInline>
            <RotateIcon type={IconType.CaretDd} isRotated={false} size={IconSize.Small} />
          </Button>
        </FlexRow>
        {expandedState ? (
          <>
            <ModalSubstrate onClick={toggleExpansion} />
            <StyledItemMetaDataModalCard modal={true}>
              <div ref={cardModal}>
                <CostDataModal
                  title={expandedLabel || label}
                  onToggle={toggleExpansion}
                  className={hideBorder ? 'cost-data--hide-border' : ''}
                >
                  {children}
                </CostDataModal>
              </div>
            </StyledItemMetaDataModalCard>
          </>
        ) : null}
      </>
    );
  }
);

export default PurchaseItemMetaDataModal;
